import {soundOnSvg as Icon__small__soundOnSvg} from '../Icon__small/Icon__small--soundOn.js';

export var soundOn = {
  name: 'soundOn',
  category: 'icon',
  colorable: true,
  svg: Icon__small__soundOnSvg,
};
